import React from 'react';
import classNames from 'classnames';



let QED = function(props) {

    
    return (
        <div {...props}>
            {props.children}
        </div>
    );
}


QED.Table = function(props) {

    var {hover = true, responsive = true, className, ...props} = props;

    className = classNames('table');
    className = classNames(className, hover ? 'table-hover' : null);
    className = classNames(className, responsive ? 'table-responsive' : null);

    
    return (
        <table {...props} className={className}>
            {props.children}
        </table>
    );
}

QED.Tag = function(props) {

    var {tag:Tag, ...props} = props;

    return (
        <Tag {...props}>
            {props.children}
        </Tag>
    );

}


QED.Header = function(props) {

    return QED.Tag({tag:'thead', ...props});
}

QED.Body = function(props) {

    return QED.Tag({tag:'tbody', ...props});
}

QED.Row = function(props) {

    var {cells, align = 'middle', color, selected, className, ...props} = props;

    if (align)
        className = classNames(className, `align-${align}`);

    if (color)
        className = classNames(className, `table-${color}`)

    if (selected)
        className = classNames(className, 'table-primary')

    let renderChildren = () => {
        if (cells == undefined)
            return props.children;
            
        return cells.map((cell, index) => {
            let {children, ...props} = cell;
    
            return (
                <QED.Cell key={index} {...props}>{children}</QED.Cell>
            );

        });
    };

    return (
        <QED.Tag tag='tr' {...props} className={className} >
            {renderChildren()}
        </QED.Tag>
    );
}


QED.Columns = function(props) {

    return QED.Tag({tag:'tr', ...props});
}

QED.Column = function(options) {

    let {sort, className, align, ...props} = options;

    switch(align) {
        case 'left':
            className = classNames(className, 'text-start');
            break;
        case 'right':
            className = classNames(className, 'text-end');
            break;
        case 'center':
            className = classNames(className, 'text-center');
            break;
    }

    let renderSort = () => {

        let symbol = undefined;

        switch(sort) {
            case 'ascending':
                symbol = '▲';
                break;
            case 'descending':
                symbol = '▼';
                break;
        }

        if (symbol != undefined)
            return <span style={{fontSize:'75%'}} className='align-middle px-1'>{symbol}</span>

    }


    return (
        <QED.Tag tag='th' className={className} {...props}>
                {props.children}
                {renderSort()}
        </QED.Tag>
    );
}

QED.Cell = function(props) {

    return QED.Tag({tag:'td', ...props});
}





export default QED;
